
<ngx-ui-loader [loaderId]="'master'" [bgsOpacity]=0 [bgsPosition]="'bottom-right'" [bgsType]="'ball-spin-clockwise'"
  [fgsColor]="'rgba(255,255,255,0)'" [bgsSize]="40" [fgsPosition]="'top-center'" [fgsSize]=20 [fgsType]="'circle'"
  [gap]=10 [logoPosition]="'center-center'" [overlayBorderRadius]="'0'" [overlayColor]="'rgba(40,40,40,0.5)'"
  [pbColor]="'#db4e4e'" [pbDirection]="'ltr'" [pbThickness]=5 [hasProgressBar]=true></ngx-ui-loader>
<router-outlet></router-outlet>
